import { Redirect, Route, Switch } from "react-router";
import About from "../About/About";
import Login from "../Authentication/Login";
import Register from "../Authentication/Register";
import AddEvent from "../Event/AddEvent";
import EditEvent from "../Event/EditEvent";
import Event from "../Event/Event";
import EditUser from "../Home/EditUser";
import Home from "../Home/Home";
import LoginRoute from "./LoginRoutes";
import PrivateRoute from "./PrivateRoutes";

const Routes = () => {
    return (
        <Switch>
            <Route exact path="/" component={Home}/>
            <LoginRoute exact path="/login" component={Login}/>
            <PrivateRoute exact path="/user/new" component={Register}/>
            <Route exact path="/about" component={About}/>
            <PrivateRoute exact path="/user/:id" component={EditUser}/>
            <Route exact path="/event" component={Event}/>
            <PrivateRoute exact path="/event/post" component={AddEvent}/>
            <PrivateRoute exact path="/event/:id" component={EditEvent}/>
            <Route render={() => <Redirect to={{pathname: "/"}} />} />

        </Switch>
    )
}

export default Routes;